import {Store, Module, ActionContext} from 'vuex';
import ListModule from '../list-module';
import ListState from '../list-state';
import Order from '@/store/entities/ordering/Order';
import Ajax from '@/lib/ajaxOrdering';
import PageResult from '@/store/entities/page-result';
import Util from '@/lib/util';

interface OrderState extends ListState<Order>{
    editOrder: Order;
    loading: boolean;
    list4vendor: Array<Order>;
}

class OrderModule extends ListModule<OrderState, any, Order>{
    state={
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Order>(),
        list4vendor: new Array<Order>(),
        loading: false,
        editOrder: new Order(),
    }
    actions={
        async getAllByVendor(context: ActionContext<OrderState, any>, payload: any){
            context.state.loading = true;
            let response = await Ajax.get('/Order/getAllByVendor', { params: payload.data });
            context.state.loading = false;
            let page = response.data.result as PageResult<Order>;
            context.state.totalCount = page.totalCount;

            page.items.forEach(x=>{
                x.creationTime = x.creationTime.substring(0, 16).replace('T', ' '); //Util.formatDate(new Date(x.creationTime), 'yyyy-MM-dd');
            });

            context.state.list4vendor = page.items;
        },
        async getAllByUser(context: ActionContext<OrderState, any>, payload: any){
            context.state.loading = true;
            let response = await Ajax.get('/Order/getAllByUser', { params: payload.data });
            context.state.loading = false;
            let page = response.data.result as PageResult<Order>;
            context.state.totalCount = page.totalCount;

            page.items.forEach(x=>{
                x.creationTime = x.creationTime.substring(0, 16).replace('T', ' '); //Util.formatDate(new Date(x.creationTime), 'yyyy-MM-dd');
            });

            context.state.list = page.items;
        },
        async create(context: ActionContext<OrderState, any>, payload: any){
            return await Ajax.post('/Order/Create', payload.data);
        },
        async update(context: ActionContext<OrderState, any>, payload: any){
            await Ajax.put('/Order/Update', payload.data);
        },
        async takeDelivery(context: ActionContext<OrderState, any>, payload: any){
            return await Ajax.put('/Order/takeDelivery?orderNo=' + payload.data);
        },
        async applyRefund(context: ActionContext<OrderState, any>, payload: any){
            return await Ajax.put('/Order/applyRefund?orderNo=' + payload.data);
        },
        async approveRefund(context: ActionContext<OrderState, any>, payload: any){
            return await Ajax.put('/Order/approveRefund?orderNo=' + payload.data.orderNo + '&userNo=' + payload.data.userNo + '&vendorNo=' + payload.data.vendorNo);
        },
        async delete(context: ActionContext<OrderState, any>, payload: any){
            await Ajax.delete('/Order/Delete?Id=' + payload.data.id);
        },
        async getByNo(context: ActionContext<OrderState, any>, payload: any){
            let response = await Ajax.get('/Order/GetByNo?no=' + payload.data.orderNo);
            context.state.editOrder = response.data.result as Order; // set value for editing.
            return response.data.result as Order;
        },
    };
    mutations={
        setCurrentPage(state: OrderState, page: number){
            state.currentPage = page;
        },
        setPageSize(state: OrderState, pagesize: number){
            state.pageSize = pagesize;
        }
    }
}
const orderModule = new OrderModule();
export default orderModule;